"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.magdalena.description': 'Voce grave e calda con forza tranquilla e sottigliezza.',
};
